export default __webpack_public_path__ + "static/media/40308.e85c6001.jpg";